import React, {useState, useEffect} from "react"
import PlayingCard from "./PlayingCard"
import playingCardData from "./playingCardData"
import ClockTimer from "./ClockTimer"

function MemoryGame(props) {
    const [countdownInterval, setCountdownInterval] = useState("")
    const [timeLeft, setTimeLeft] = useState(0)
    const [clockRotation, setClockRotation] = useState(360 / props.timeLimit)
    const [rotateStep, setRotateStep] = useState(0)
    const [attempt, setAttempt] = useState(1)
    const [turn, setTurn] = useState(0)
    const [previousCard, setPreviousCard] = useState("")
    const [win, setWin] = useState("")
    const [maxTurns] = useState(7) 
    
    useEffect(() => {
            if (props.startCountdown) { setCountdownInterval(setInterval(() => countdown(), 1000)) } 
    }, [props.startCountdown])

    function countdown() {        
        setTimeLeft(prevTime => prevTime - 1)
    }
    
    useEffect(() => {
        if (win) {
            return function countdownCleanUp() {
                clearInterval(countdownInterval)
            }
        }
    },[win, countdownInterval])
           
    useEffect(() => { 
        if (timeLeft <= 0) { 
            setWin(false)
            checkWin()
            setTimeout(() => {
                attempt >= 3 ? setAttempt(1) : setAttempt(prevAttempt => prevAttempt + 1)
            }, 700)
        }
        const updateRotate = rotateStep + clockRotation
        setRotateStep(updateRotate)
        const rotation = "rotate(" + updateRotate + "deg)"
        if (props.timeLimit !== undefined) { document.getElementById("secondHandRotate").style.transform = rotation }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeLeft, attempt])
    
    useEffect(() => {
        setTimeLeft(props.timeLimit)
        const game = document.getElementById("memoryGameWrapper")
        if (attempt === 1) {
            game.classList.remove("shuffleThree")
            game.classList.add("shuffleOne")
        } else if (attempt === 2) {
            game.classList.remove("shuffleOne")
            game.classList.add("shuffleTwo")
        } else if (attempt === 3) {
            game.classList.remove("shuffleTwo")
            game.classList.add("shuffleThree")
        }
        setRotateStep(0)
        setClockRotation(360 / props.timeLimit)
    }, [attempt, props.timeLimit])
    
    
    function callBackFlip(name, match) {
        document.getElementById(name).classList.add("playingCardClicked")
        
        if (previousCard === "") {
            setPreviousCard(name)
        } else if (previousCard !== match) {
            setWin(false)
            setTimeout(() => checkWin(), 750)
        } else {
            setTurn(prevTurn => prevTurn + 1)
            setPreviousCard("")   
        }
    }

    function checkWin() {
        if (!win) {
            let clickedCards = Array.from(document.querySelectorAll(".playingCardClicked"))
            clickedCards.map(card => card.classList.remove("playingCardClicked"))
            setPreviousCard("")
            setTurn(0)
        }
    }
    
    useEffect(() => {
        if (turn >= maxTurns) {
            setTimeout(() => props.callBackMemory(true), 1000)
            document.getElementById("fourJokersWrapper").style.minHeight = "700px"
            setWin(true)
        }
    }, [turn, maxTurns, props])
    
    const playingCards = playingCardData.map(card => {
        return (
            <PlayingCard key={card.index} name={card.name} match={card.match} cardText={card.cardText} callBackFlip={callBackFlip} />  
        )
    })
    
    return (
        <div>
            <div id="memoryGameWrapper" className="shuffleOne">
                <h3 className="phaseIntro">Beat the game to hear Jack's info. If the timer reaches zero, the cards will reshuffle.</h3>
                {playingCards}
                {props.timeLimit !== undefined ? <ClockTimer timeLeft={timeLeft} /> : "" }
            </div>
            <h3><em>Need more time? Request a hint.</em></h3>
        </div>
    )
}

export default MemoryGame